const addReserveSite= () => import('@/views/main/reserve/site/cpns/add-site/add-site.vue')
export default {
  path: '/main/reserve/addReserveSite',
  name: 'addReserveSite',
  component:addReserveSite,
  children: []
}
